var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.wijziging
    ? _c(
        "div",
        _vm._l(_vm.wijziging.steps, function(step, index) {
          return _c(
            "div",
            {
              key: "wijziging-step-div-" + parseInt(index),
              staticClass: "container"
            },
            [
              index === 0
                ? _c("div", { staticClass: "row mb-4" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-1 text-secondary" },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: ["fad", "user"] }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.cardName === "personeelslid"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "w-75 border-left border-secondary pl-3 col-sm-11"
                          },
                          [
                            step.changes
                              ? _c(
                                  "dl",
                                  { staticClass: "row" },
                                  [
                                    step.changes.naam
                                      ? [
                                          _c(
                                            "dt",
                                            { staticClass: "col-sm-3" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.labels.personeelslid.naam
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "dd",
                                            {
                                              staticClass: "col-sm-9 text-left"
                                            },
                                            [_vm._v(_vm._s(step.changes.naam))]
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    step.changes.voornaam
                                      ? [
                                          _c(
                                            "dt",
                                            { staticClass: "col-sm-3" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.labels.personeelslid
                                                    .voornaam
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "dd",
                                            {
                                              staticClass: "col-sm-9 text-left"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(step.changes.voornaam)
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    step.changes.voornaam2
                                      ? [
                                          _c(
                                            "dt",
                                            { staticClass: "col-sm-3" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.labels.personeelslid
                                                    .voornaam2
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "dd",
                                            {
                                              staticClass: "col-sm-9 text-left"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(step.changes.voornaam2)
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    step.changes.roepnaam
                                      ? [
                                          _c(
                                            "dt",
                                            { staticClass: "col-sm-3" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.labels.personeelslid
                                                    .roepnaam
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "dd",
                                            {
                                              staticClass: "col-sm-9 text-left"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(step.changes.roepnaam)
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    step.changes.geboortedatum
                                      ? [
                                          _c(
                                            "dt",
                                            { staticClass: "col-sm-3" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.labels.personeelslid
                                                    .geboortedatum
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "dd",
                                            {
                                              staticClass: "col-sm-9 text-left"
                                            },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(
                                                    step.changes.geboortedatum
                                                  ) +
                                                  "\n            "
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    step.changes.geboorteplaats
                                      ? [
                                          _c(
                                            "dt",
                                            { staticClass: "col-sm-3" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.labels.personeelslid
                                                    .geboorteplaats
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "dd",
                                            {
                                              staticClass: "col-sm-9 text-left"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  step.changes.geboorteplaats
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    step.changes.geboorteland
                                      ? [
                                          _c(
                                            "dt",
                                            { staticClass: "col-sm-3" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.labels.personeelslid
                                                    .geboorteland
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "dd",
                                            {
                                              staticClass: "col-sm-9 text-left"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  step.changes.geboorteland.land
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    step.changes.persMindervalide
                                      ? [
                                          _c(
                                            "dt",
                                            { staticClass: "col-sm-3" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.labels.personeelslid
                                                    .persMindervalide
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "dd",
                                            {
                                              staticClass: "col-sm-9 text-left"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  step.changes.persMindervalide
                                                    ? "Ja"
                                                    : "Nee"
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    step.changes.geslacht
                                      ? [
                                          _c(
                                            "dt",
                                            { staticClass: "col-sm-3" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.labels.personeelslid
                                                    .geslacht
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "dd",
                                            {
                                              staticClass: "col-sm-9 text-left"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(step.changes.geslacht)
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    step.changes.inszNr
                                      ? [
                                          _c(
                                            "dt",
                                            { staticClass: "col-sm-3" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.labels.personeelslid
                                                    .inszNr
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "dd",
                                            {
                                              staticClass: "col-sm-9 text-left"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(step.changes.inszNr)
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    step.changes.natio
                                      ? [
                                          _c(
                                            "dt",
                                            { staticClass: "col-sm-3" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.labels.personeelslid.natio
                                                    .objectName.plural
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            step.changes.natio.added,
                                            function(natio, index) {
                                              return step.changes.natio.added
                                                ? [
                                                    _c(
                                                      "dd",
                                                      {
                                                        key:
                                                          "dd-step-natio-added" +
                                                          parseInt(index),
                                                        staticClass:
                                                          "col-sm-9 text-left text-success"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                (+) " +
                                                            _vm._s(
                                                              natio.nationaliteit
                                                            ) +
                                                            "\n              "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("dt", {
                                                      key:
                                                        "dt-step-natio-added" +
                                                        parseInt(index),
                                                      staticClass: "col-sm-3"
                                                    })
                                                  ]
                                                : _vm._e()
                                            }
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            step.changes.natio.removed,
                                            function(natio, index) {
                                              return step.changes.natio.removed
                                                ? [
                                                    _c(
                                                      "dd",
                                                      {
                                                        key:
                                                          "dd-step-natio-removed" +
                                                          parseInt(index),
                                                        staticClass:
                                                          "col-sm-9 text-left text-danger"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                (-) " +
                                                            _vm._s(
                                                              natio.nationaliteit
                                                            ) +
                                                            "\n              "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("dt", {
                                                      key:
                                                        "dt-step-natio-removed" +
                                                        parseInt(index),
                                                      staticClass: "col-sm-3"
                                                    })
                                                  ]
                                                : _vm._e()
                                            }
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            step.remarks
                              ? _c("dl", { staticClass: "row" }, [
                                  _c("dt", { staticClass: "col-sm-3" }, [
                                    _vm._v("Opmerking")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "dd",
                                    { staticClass: "col-sm-9 text-left" },
                                    [_vm._v(_vm._s(step.remarks))]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            step.files
                              ? _c(
                                  "dl",
                                  { staticClass: "row" },
                                  [
                                    _c("dt", { staticClass: "col-sm-3" }, [
                                      _vm._v("Bijlage(n)")
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(step.files, function(file, index) {
                                      return [
                                        _c(
                                          "dd",
                                          {
                                            key:
                                              "dd-step-files-personeelslid-" +
                                              parseInt(index),
                                            staticClass:
                                              "col-sm-9 text-left text-primary"
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    return _vm.downloadDossierFile(
                                                      file
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: ["fad", "download"]
                                                  }
                                                }),
                                                _vm._v(
                                                  "\n                - " +
                                                    _vm._s(file.bestandsnaam) +
                                                    "\n              "
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("dt", {
                                          key:
                                            "dt-step-files-personeelslid-" +
                                            parseInt(index),
                                          staticClass: "col-sm-3"
                                        })
                                      ]
                                    })
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-left" }, [
                              _c(
                                "span",
                                { staticClass: "text-muted font-italic" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: ["fad", "calendar"] }
                                  }),
                                  _vm._v(
                                    "\n                          " +
                                      _vm._s(step.created) +
                                      "\n                      "
                                  )
                                ],
                                1
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.cardName == "contact"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "w-75 border-left border-primary pl-3 col-sm-11"
                          },
                          [
                            step.changes
                              ? _c(
                                  "dl",
                                  { staticClass: "row" },
                                  [
                                    step.changes.woonplaats
                                      ? [
                                          _vm._l(
                                            step.changes.woonplaats.added,
                                            function(woonplaats, index) {
                                              return step.changes.woonplaats
                                                .added
                                                ? [
                                                    _c(
                                                      "dt",
                                                      {
                                                        key:
                                                          "dt-woonplaats-added-" +
                                                          parseInt(index),
                                                        staticClass: "col-sm-3"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                " +
                                                            _vm._s(
                                                              _vm.labels.contact
                                                                .woonplaats
                                                                .objectName
                                                                .singular
                                                            ) +
                                                            "\n              "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "dd",
                                                      {
                                                        key:
                                                          "dd-woonplaats-added-" +
                                                          parseInt(index),
                                                        staticClass:
                                                          "col-sm-9 text-left text-success"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                (+) " +
                                                            _vm._s(
                                                              woonplaats.straat
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              woonplaats.nr
                                                            ) +
                                                            "\n                " +
                                                            _vm._s(
                                                              woonplaats.bus
                                                            )
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "\n                " +
                                                            _vm._s(
                                                              woonplaats.hfdPostnr
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              woonplaats.deelgemeente
                                                            )
                                                        ),
                                                        _c("br")
                                                      ]
                                                    )
                                                  ]
                                                : _vm._e()
                                            }
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            step.changes.woonplaats.removed,
                                            function(woonplaats, index) {
                                              return step.changes.woonplaats
                                                .removed
                                                ? [
                                                    _c(
                                                      "dt",
                                                      {
                                                        key:
                                                          "dt-woonplaats-removed-" +
                                                          parseInt(index),
                                                        staticClass: "col-sm-3"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                " +
                                                            _vm._s(
                                                              _vm.labels.contact
                                                                .woonplaats
                                                                .objectName
                                                                .singular
                                                            ) +
                                                            "\n              "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "dd",
                                                      {
                                                        key:
                                                          "dd-woonplaats-removed-" +
                                                          parseInt(index),
                                                        staticClass:
                                                          "col-sm-9 text-left text-danger"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                (-) " +
                                                            _vm._s(
                                                              woonplaats.straat
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              woonplaats.nr
                                                            ) +
                                                            "\n                " +
                                                            _vm._s(
                                                              woonplaats.bus
                                                            )
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "\n                " +
                                                            _vm._s(
                                                              woonplaats.hfdPostnr
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              woonplaats.deelgemeente
                                                            )
                                                        ),
                                                        _c("br")
                                                      ]
                                                    )
                                                  ]
                                                : _vm._e()
                                            }
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    step.changes.verblijfplaats
                                      ? [
                                          _vm._l(
                                            step.changes.verblijfplaats.added,
                                            function(verblijfplaats, index) {
                                              return step.changes.verblijfplaats
                                                .added
                                                ? [
                                                    _c(
                                                      "dt",
                                                      {
                                                        key:
                                                          "dt-verblijfplaats-added-" +
                                                          parseInt(index),
                                                        staticClass: "col-sm-3"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                " +
                                                            _vm._s(
                                                              _vm.labels.contact
                                                                .verblijfplaats
                                                                .objectName
                                                                .singular
                                                            ) +
                                                            "\n              "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "dd",
                                                      {
                                                        key:
                                                          "dd-verblijfplaats-added-" +
                                                          parseInt(index),
                                                        staticClass:
                                                          "col-sm-9 text-left text-success"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                (+) " +
                                                            _vm._s(
                                                              verblijfplaats.straat
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              verblijfplaats.nr
                                                            ) +
                                                            "\n                " +
                                                            _vm._s(
                                                              verblijfplaats.bus
                                                            )
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "\n                " +
                                                            _vm._s(
                                                              verblijfplaats.hfdPostnr
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              verblijfplaats.deelgemeente
                                                            )
                                                        ),
                                                        _c("br")
                                                      ]
                                                    )
                                                  ]
                                                : _vm._e()
                                            }
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            step.changes.verblijfplaats.removed,
                                            function(verblijfplaats, index) {
                                              return step.changes.verblijfplaats
                                                .removed
                                                ? [
                                                    _c(
                                                      "dt",
                                                      {
                                                        key:
                                                          "dt-verblijfplaats-removed-" +
                                                          parseInt(index),
                                                        staticClass: "col-sm-3"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                " +
                                                            _vm._s(
                                                              _vm.labels.contact
                                                                .verblijfplaats
                                                                .objectName
                                                                .singular
                                                            ) +
                                                            "\n              "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "dd",
                                                      {
                                                        key:
                                                          "dd-verblijfplaats-removed-" +
                                                          parseInt(index),
                                                        staticClass:
                                                          "col-sm-9 text-left text-danger"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                (-) " +
                                                            _vm._s(
                                                              verblijfplaats.straat
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              verblijfplaats.nr
                                                            ) +
                                                            "\n                " +
                                                            _vm._s(
                                                              verblijfplaats.bus
                                                            )
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "\n                " +
                                                            _vm._s(
                                                              verblijfplaats.hfdPostnr
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              verblijfplaats.deelgemeente
                                                            )
                                                        ),
                                                        _c("br")
                                                      ]
                                                    )
                                                  ]
                                                : _vm._e()
                                            }
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    step.changes.correspondentie
                                      ? [
                                          _vm._l(
                                            step.changes.correspondentie.added,
                                            function(correspondentie, index) {
                                              return step.changes
                                                .correspondentie.added
                                                ? [
                                                    _c(
                                                      "dt",
                                                      {
                                                        key:
                                                          "dt-correspondentie-added-" +
                                                          parseInt(index),
                                                        staticClass: "col-sm-3"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                " +
                                                            _vm._s(
                                                              _vm.labels.contact
                                                                .correspondentie
                                                                .objectName
                                                                .singular
                                                            ) +
                                                            "\n              "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "dd",
                                                      {
                                                        key:
                                                          "dd-corespondentie-added-" +
                                                          parseInt(index),
                                                        staticClass:
                                                          "col-sm-9 text-left text-success"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                (+) " +
                                                            _vm._s(
                                                              correspondentie.straat
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              correspondentie.nr
                                                            ) +
                                                            "\n                " +
                                                            _vm._s(
                                                              correspondentie.bus
                                                            )
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "\n                " +
                                                            _vm._s(
                                                              correspondentie.hfdPostnr
                                                            ) +
                                                            "\n                " +
                                                            _vm._s(
                                                              correspondentie.deelgemeente
                                                            )
                                                        ),
                                                        _c("br")
                                                      ]
                                                    )
                                                  ]
                                                : _vm._e()
                                            }
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            step.changes.correspondentie
                                              .removed,
                                            function(correspondentie, index) {
                                              return step.changes
                                                .correspondentie.removed
                                                ? [
                                                    _c(
                                                      "dt",
                                                      {
                                                        key:
                                                          "dt-correspondentie-removed-" +
                                                          parseInt(index),
                                                        staticClass: "col-sm-3"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                " +
                                                            _vm._s(
                                                              _vm.labels.contact
                                                                .correspondentie
                                                                .objectName
                                                                .singular
                                                            ) +
                                                            "\n              "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "dd",
                                                      {
                                                        key:
                                                          "dd-correspondentie-removed-" +
                                                          parseInt(index),
                                                        staticClass:
                                                          "col-sm-9 text-left text-danger"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                (-) " +
                                                            _vm._s(
                                                              correspondentie.straat
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              correspondentie.nr
                                                            ) +
                                                            "\n                " +
                                                            _vm._s(
                                                              correspondentie.bus
                                                            )
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "\n                " +
                                                            _vm._s(
                                                              correspondentie.hfdPostnr
                                                            ) +
                                                            "\n                " +
                                                            _vm._s(
                                                              correspondentie.deelgemeente
                                                            )
                                                        ),
                                                        _c("br")
                                                      ]
                                                    )
                                                  ]
                                                : _vm._e()
                                            }
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    step.changes.comnummer
                                      ? [
                                          _vm._l(
                                            step.changes.comnummer.added,
                                            function(number, index) {
                                              return step.changes.comnummer
                                                .added
                                                ? [
                                                    _c(
                                                      "dt",
                                                      {
                                                        key:
                                                          "dt-comnummer-added-" +
                                                          parseInt(index),
                                                        staticClass: "col-sm-3"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                " +
                                                            _vm._s(
                                                              number.type
                                                            ) +
                                                            "\n              "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "dd",
                                                      {
                                                        key:
                                                          "dd-comnummer-added-" +
                                                          parseInt(index),
                                                        staticClass:
                                                          "col-sm-9 text-left text-success"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                (+) " +
                                                            _vm._s(
                                                              number.nummer !=
                                                                ""
                                                                ? number.nummer
                                                                : "Geen nummer"
                                                            ) +
                                                            "\n                "
                                                        ),
                                                        number.type ==
                                                        "Noodnummer"
                                                          ? [
                                                              _c("br"),
                                                              _vm._v(
                                                                "\n                " +
                                                                  _vm._s(
                                                                    number.opm
                                                                  ) +
                                                                  "\n                "
                                                              )
                                                            ]
                                                          : _vm._e()
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                : _vm._e()
                                            }
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            step.changes.comnummer.removed,
                                            function(number, index) {
                                              return step.changes.comnummer
                                                .removed
                                                ? [
                                                    _c(
                                                      "dt",
                                                      {
                                                        key:
                                                          "dt-comnummer-removed-" +
                                                          parseInt(index),
                                                        staticClass: "col-sm-3"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                " +
                                                            _vm._s(
                                                              number.type
                                                            ) +
                                                            "\n              "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "dd",
                                                      {
                                                        key:
                                                          "dd-comnummer-removed-" +
                                                          parseInt(index),
                                                        staticClass:
                                                          "col-sm-9 text-left text-danger"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                (-) " +
                                                            _vm._s(
                                                              number.nummer !=
                                                                ""
                                                                ? number.nummer
                                                                : "Geen nummer"
                                                            ) +
                                                            "\n              "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                : _vm._e()
                                            }
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    step.changes.email
                                      ? [
                                          _vm._l(
                                            step.changes.email.added,
                                            function(email, index) {
                                              return step.changes.email.added
                                                ? [
                                                    _c(
                                                      "dt",
                                                      {
                                                        key:
                                                          "dt-email-added-" +
                                                          parseInt(index),
                                                        staticClass: "col-sm-3"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                " +
                                                            _vm._s(
                                                              _vm.labels.contact
                                                                .email
                                                                .emailAdres
                                                            ) +
                                                            "\n              "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "dd",
                                                      {
                                                        key:
                                                          "dd-email-added-" +
                                                          parseInt(index),
                                                        staticClass:
                                                          "col-sm-9 text-left text-success"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                (+) " +
                                                            _vm._s(
                                                              email.emailAdres
                                                            ) +
                                                            "\n              "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                : _vm._e()
                                            }
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            step.changes.email.removed,
                                            function(email, index) {
                                              return step.changes.email.removed
                                                ? [
                                                    _c(
                                                      "dt",
                                                      {
                                                        key:
                                                          "dt-email-removed-" +
                                                          parseInt(index),
                                                        staticClass: "col-sm-3"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                " +
                                                            _vm._s(
                                                              _vm.labels.contact
                                                                .email
                                                                .emailAdres
                                                            ) +
                                                            "\n              "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "dd",
                                                      {
                                                        key:
                                                          "dd-email-removed-" +
                                                          parseInt(index),
                                                        staticClass:
                                                          "col-sm-9 text-left text-danger"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                (-) " +
                                                            _vm._s(
                                                              email.emailAdres
                                                            ) +
                                                            "\n              "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                : _vm._e()
                                            }
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    step.changes.werkEmail
                                      ? [
                                          _vm._l(
                                            step.changes.werkEmail.added,
                                            function(email, index) {
                                              return step.changes.werkEmail
                                                .added
                                                ? [
                                                    _c(
                                                      "dt",
                                                      {
                                                        key:
                                                          "dt-werk-email-added-" +
                                                          parseInt(index),
                                                        staticClass: "col-sm-3"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                " +
                                                            _vm._s(
                                                              _vm.labels.contact
                                                                .email
                                                                .emailAdres
                                                            ) +
                                                            "\n              "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "dd",
                                                      {
                                                        key:
                                                          "dd-werk-email-added-" +
                                                          parseInt(index),
                                                        staticClass:
                                                          "col-sm-9 text-left text-success"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                (+) " +
                                                            _vm._s(
                                                              email.emailAdres
                                                            ) +
                                                            "\n              "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                : _vm._e()
                                            }
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            step.changes.werkEmail.removed,
                                            function(email, index) {
                                              return step.changes.werkEmail
                                                .removed
                                                ? [
                                                    _c(
                                                      "dt",
                                                      {
                                                        key:
                                                          "dt-werk-email-removed-" +
                                                          parseInt(index),
                                                        staticClass: "col-sm-3"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                " +
                                                            _vm._s(
                                                              _vm.labels.contact
                                                                .werkEmail
                                                                .emailAdres
                                                            ) +
                                                            "\n              "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "dd",
                                                      {
                                                        key:
                                                          "dd-werk-email-removed-" +
                                                          parseInt(index),
                                                        staticClass:
                                                          "col-sm-9 text-left text-danger"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                (-) " +
                                                            _vm._s(
                                                              email.emailAdres
                                                            ) +
                                                            "\n              "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                : _vm._e()
                                            }
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            step.remarks
                              ? _c("dl", { staticClass: "row" }, [
                                  _c("dt", { staticClass: "col-sm-3" }, [
                                    _vm._v("Opmerking")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "dd",
                                    { staticClass: "col-sm-9 text-left" },
                                    [_vm._v(_vm._s(step.remarks))]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            step.files
                              ? _c(
                                  "dl",
                                  { staticClass: "row" },
                                  [
                                    _c("dt", { staticClass: "col-sm-3" }, [
                                      _vm._v("Bijlage(n)")
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(step.files, function(file, index) {
                                      return [
                                        _c(
                                          "dd",
                                          {
                                            key:
                                              "dd-step-files-contact-" +
                                              parseInt(index),
                                            staticClass:
                                              "col-sm-9 text-left text-primary"
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    return _vm.downloadDossierFile(
                                                      file
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: ["fad", "download"]
                                                  }
                                                }),
                                                _vm._v(
                                                  "\n                - " +
                                                    _vm._s(file.bestandsnaam) +
                                                    "\n              "
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("dt", {
                                          key:
                                            "dt-step-files-contact-" +
                                            parseInt(index),
                                          staticClass: "col-sm-3"
                                        })
                                      ]
                                    })
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-left" }, [
                              _c(
                                "span",
                                { staticClass: "text-muted font-italic" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: ["fad", "calendar"] }
                                  }),
                                  _vm._v(
                                    "\n                          " +
                                      _vm._s(step.created) +
                                      "\n                      "
                                  )
                                ],
                                1
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.cardName == "gezin"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "w-75 border-left border-primary pl-3 col-sm-11"
                          },
                          [
                            step.changes
                              ? [
                                  step.changes.burgStaat
                                    ? _c(
                                        "dl",
                                        { staticClass: "row" },
                                        [
                                          step.changes.burgStaat.burgstaat
                                            ? [
                                                _c(
                                                  "dt",
                                                  {
                                                    staticClass:
                                                      "col-sm-3 text-left"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.labels.gezin
                                                          .burgStaat.burgstaat
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "dd",
                                                  {
                                                    staticClass:
                                                      "col-sm-9 text-left"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        step.changes.burgStaat
                                                          .burgstaat
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          step.changes.burgStaat.burgstaatDatum
                                            ? [
                                                _c(
                                                  "dt",
                                                  {
                                                    staticClass:
                                                      "col-sm-3 text-left"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.labels.gezin
                                                          .burgStaat
                                                          .burgstaatDatum
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "dd",
                                                  {
                                                    staticClass:
                                                      "col-sm-9 text-left"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        step.changes.burgStaat
                                                          .burgstaatDatum
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          step.changes.burgStaat.huwelijksdatum
                                            ? [
                                                _c(
                                                  "dt",
                                                  {
                                                    staticClass:
                                                      "col-sm-3 text-left"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.labels.gezin
                                                          .burgStaat
                                                          .huwelijksdatum
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "dd",
                                                  {
                                                    staticClass:
                                                      "col-sm-9 text-left"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        step.changes.burgStaat
                                                          .huwelijksdatum
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  step.changes.partner
                                    ? [
                                        _c("h5", { staticClass: "text-left" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.labels.gezin.partner
                                                .objectName
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "dl",
                                          { staticClass: "row text-left" },
                                          [
                                            step.changes.partner.naam
                                              ? [
                                                  _c(
                                                    "dt",
                                                    { staticClass: "col-sm-3" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.labels.gezin
                                                            .partner.naam
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "dd",
                                                    { staticClass: "col-sm-9" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          step.changes.partner
                                                            .naam
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            step.changes.partner.voornaam
                                              ? [
                                                  _c(
                                                    "dt",
                                                    { staticClass: "col-sm-3" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.labels.gezin
                                                            .partner.voornaam
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "dd",
                                                    { staticClass: "col-sm-9" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          step.changes.partner
                                                            .voornaam
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            step.changes.partner.nationaliteit
                                              ? [
                                                  _c(
                                                    "dt",
                                                    { staticClass: "col-sm-3" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.labels.gezin
                                                            .partner
                                                            .nationaliteit
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "dd",
                                                    { staticClass: "col-sm-9" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          step.changes.partner
                                                            .nationaliteit
                                                            .nationaliteit
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            step.changes.partner.geboortedatum
                                              ? [
                                                  _c(
                                                    "dt",
                                                    { staticClass: "col-sm-3" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.labels.gezin
                                                            .partner
                                                            .geboortedatum
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "dd",
                                                    { staticClass: "col-sm-9" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          step.changes.partner
                                                            .geboortedatum
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            step.changes.partner.geboorteplaats
                                              ? [
                                                  _c(
                                                    "dt",
                                                    { staticClass: "col-sm-3" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.labels.gezin
                                                            .partner
                                                            .geboorteplaats
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "dd",
                                                    { staticClass: "col-sm-9" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          step.changes.partner
                                                            .geboorteplaats
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            step.changes.partner.hasOwnProperty(
                                              "mindervalide"
                                            )
                                              ? [
                                                  _c(
                                                    "dt",
                                                    { staticClass: "col-sm-3" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.labels.gezin
                                                            .partner
                                                            .mindervalide
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  step.changes.partner
                                                    .mindervalide
                                                    ? _c(
                                                        "dd",
                                                        {
                                                          staticClass:
                                                            "col-sm-9"
                                                        },
                                                        [_vm._v("Ja")]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  !step.changes.partner
                                                    .mindervalide
                                                    ? _c(
                                                        "dd",
                                                        {
                                                          staticClass:
                                                            "col-sm-9"
                                                        },
                                                        [_vm._v("Nee")]
                                                      )
                                                    : _vm._e()
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            step.changes.partner.hasOwnProperty(
                                              "tenLaste"
                                            )
                                              ? [
                                                  _c(
                                                    "dt",
                                                    { staticClass: "col-sm-3" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.labels.gezin
                                                            .partner.tenLaste
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  step.changes.partner.tenLaste
                                                    ? _c(
                                                        "dd",
                                                        {
                                                          staticClass:
                                                            "col-sm-9"
                                                        },
                                                        [_vm._v("Ja")]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  !step.changes.partner.tenLaste
                                                    ? _c(
                                                        "dd",
                                                        {
                                                          staticClass:
                                                            "col-sm-9"
                                                        },
                                                        [_vm._v("Nee")]
                                                      )
                                                    : _vm._e()
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            step.changes.partner.beroep
                                              ? [
                                                  _c(
                                                    "dt",
                                                    { staticClass: "col-sm-3" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.labels.gezin
                                                            .partner.beroep
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "dd",
                                                    { staticClass: "col-sm-9" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          step.changes.partner
                                                            .beroep
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            step.changes.partner.werkgever
                                              ? [
                                                  _c(
                                                    "dt",
                                                    { staticClass: "col-sm-3" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.labels.gezin
                                                            .partner.werkgever
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "dd",
                                                    { staticClass: "col-sm-9" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          step.changes.partner
                                                            .werkgever
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            step.changes.partner
                                              .partnOverlijdensdatum
                                              ? [
                                                  _c(
                                                    "dt",
                                                    { staticClass: "col-sm-3" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.labels.gezin
                                                            .partner
                                                            .overlijdensdatum
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "dd",
                                                    { staticClass: "col-sm-9" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          step.changes.partner
                                                            .partnOverlijdensdatum
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  step.changes.gezinsleden
                                    ? [
                                        step.changes.gezinsleden.added
                                          ? [
                                              _c(
                                                "h5",
                                                { staticClass: "text-left" },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.labels.gezin
                                                          .gezinsleden
                                                          .objectName.plural
                                                      ) +
                                                      "\n              "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                step.changes.gezinsleden.added,
                                                function(gezinslid, index) {
                                                  return _c(
                                                    "dl",
                                                    {
                                                      key:
                                                        "dl-gezinsleden-added-" +
                                                        parseInt(index),
                                                      class: [
                                                        index != 0
                                                          ? "border-top pt-3"
                                                          : "",
                                                        "row",
                                                        "text-left",
                                                        "text-success"
                                                      ]
                                                    },
                                                    [
                                                      _c(
                                                        "dt",
                                                        {
                                                          staticClass:
                                                            "col-sm-3"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.labels.gezin
                                                                .gezinsleden
                                                                .naam
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "dd",
                                                        {
                                                          staticClass:
                                                            "col-sm-9"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              gezinslid.naam
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "dt",
                                                        {
                                                          staticClass:
                                                            "col-sm-3"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.labels.gezin
                                                                  .gezinsleden
                                                                  .voornaam
                                                              ) +
                                                              "\n                "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "dd",
                                                        {
                                                          staticClass:
                                                            "col-sm-9"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              gezinslid.voornaam
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "dt",
                                                        {
                                                          staticClass:
                                                            "col-sm-3"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.labels.gezin
                                                                  .gezinsleden
                                                                  .geboortedatum
                                                              ) +
                                                              "\n                "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "dd",
                                                        {
                                                          staticClass:
                                                            "col-sm-9"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              gezinslid.geboortedatum
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      gezinslid.overlijdensdatum !=
                                                      null
                                                        ? [
                                                            _c(
                                                              "dt",
                                                              {
                                                                staticClass:
                                                                  "col-sm-3"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                    " +
                                                                    _vm._s(
                                                                      _vm.labels
                                                                        .gezin
                                                                        .gezinsleden
                                                                        .overlijdensdatum
                                                                    ) +
                                                                    "\n                  "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "dd",
                                                              {
                                                                staticClass:
                                                                  "col-sm-9"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    gezinslid.overlijdensdatum
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "dt",
                                                        {
                                                          staticClass:
                                                            "col-sm-3"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.labels.gezin
                                                                  .gezinsleden
                                                                  .mindervalide
                                                              ) +
                                                              "\n                "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      gezinslid.mindervalide
                                                        ? _c(
                                                            "dd",
                                                            {
                                                              staticClass:
                                                                "col-sm-9"
                                                            },
                                                            [_vm._v("Ja")]
                                                          )
                                                        : _c(
                                                            "dd",
                                                            {
                                                              staticClass:
                                                                "col-sm-9"
                                                            },
                                                            [_vm._v("Nee")]
                                                          ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "dt",
                                                        {
                                                          staticClass:
                                                            "col-sm-3"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.labels.gezin
                                                                  .gezinsleden
                                                                  .zorgbehoevend
                                                              ) +
                                                              "\n                "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      gezinslid.zorgbehoevend
                                                        ? _c(
                                                            "dd",
                                                            {
                                                              staticClass:
                                                                "col-sm-9"
                                                            },
                                                            [_vm._v("Ja")]
                                                          )
                                                        : _c(
                                                            "dd",
                                                            {
                                                              staticClass:
                                                                "col-sm-9"
                                                            },
                                                            [_vm._v("Nee")]
                                                          ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "dt",
                                                        {
                                                          staticClass:
                                                            "col-sm-3"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.labels.gezin
                                                                  .gezinsleden
                                                                  .tenLaste
                                                              ) +
                                                              "\n                "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      gezinslid.tenLaste
                                                        ? _c(
                                                            "dd",
                                                            {
                                                              staticClass:
                                                                "col-sm-9"
                                                            },
                                                            [_vm._v("Ja")]
                                                          )
                                                        : _c(
                                                            "dd",
                                                            {
                                                              staticClass:
                                                                "col-sm-9"
                                                            },
                                                            [_vm._v("Nee")]
                                                          ),
                                                      _vm._v(" "),
                                                      !gezinslid.tenLaste
                                                        ? [
                                                            _c(
                                                              "dt",
                                                              {
                                                                staticClass:
                                                                  "col-sm-3"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                    " +
                                                                    _vm._s(
                                                                      _vm.labels
                                                                        .gezin
                                                                        .gezinsleden
                                                                        .nietMeerTenLaste
                                                                    ) +
                                                                    "\n                  "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "dd",
                                                              {
                                                                staticClass:
                                                                  "col-sm-9"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    gezinslid.nietMeerTenLaste
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "dt",
                                                        {
                                                          staticClass:
                                                            "col-sm-3"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.labels.gezin
                                                                  .gezinsleden
                                                                  .verwantschap
                                                              ) +
                                                              "\n                "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "dd",
                                                        {
                                                          staticClass:
                                                            "col-sm-9"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              gezinslid.verwantschap
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    2
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                step.changes.gezinsleden
                                                  .removed,
                                                function(gezinslid, index) {
                                                  return step.changes
                                                    .gezinsleden.removed
                                                    ? _c(
                                                        "dl",
                                                        {
                                                          key:
                                                            "dl-gezinsleden-removed-" +
                                                            parseInt(index),
                                                          class: [
                                                            index != 0
                                                              ? "border-top pt-3"
                                                              : "",
                                                            "row",
                                                            "text-left",
                                                            "text-danger"
                                                          ]
                                                        },
                                                        [
                                                          _c(
                                                            "dt",
                                                            {
                                                              staticClass:
                                                                "col-sm-3"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.labels
                                                                    .gezin
                                                                    .gezinsleden
                                                                    .naam
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "dd",
                                                            {
                                                              staticClass:
                                                                "col-sm-9"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  gezinslid.naam
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "dt",
                                                            {
                                                              staticClass:
                                                                "col-sm-3"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.labels
                                                                    .gezin
                                                                    .gezinsleden
                                                                    .voornaam
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "dd",
                                                            {
                                                              staticClass:
                                                                "col-sm-9"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  gezinslid.voornaam
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "dt",
                                                            {
                                                              staticClass:
                                                                "col-sm-3"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.labels
                                                                    .gezin
                                                                    .gezinsleden
                                                                    .geboortedatum
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "dd",
                                                            {
                                                              staticClass:
                                                                "col-sm-9"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  gezinslid.geboortedatum
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          gezinslid.overlijdensdatum !=
                                                          null
                                                            ? [
                                                                _c(
                                                                  "dt",
                                                                  {
                                                                    staticClass:
                                                                      "col-sm-3"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .labels
                                                                          .gezin
                                                                          .gezinsleden
                                                                          .overlijdensdatum
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "dd",
                                                                  {
                                                                    staticClass:
                                                                      "col-sm-9"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        gezinslid.overlijdensdatum
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "dt",
                                                            {
                                                              staticClass:
                                                                "col-sm-3"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.labels
                                                                    .gezin
                                                                    .gezinsleden
                                                                    .mindervalide
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          gezinslid.mindervalide
                                                            ? _c(
                                                                "dd",
                                                                {
                                                                  staticClass:
                                                                    "col-sm-9"
                                                                },
                                                                [_vm._v("Ja")]
                                                              )
                                                            : _c(
                                                                "dd",
                                                                {
                                                                  staticClass:
                                                                    "col-sm-9"
                                                                },
                                                                [_vm._v("Nee")]
                                                              ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "dt",
                                                            {
                                                              staticClass:
                                                                "col-sm-3"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.labels
                                                                    .gezin
                                                                    .gezinsleden
                                                                    .zorgbehoevend
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          gezinslid.zorgbehoevend
                                                            ? _c(
                                                                "dd",
                                                                {
                                                                  staticClass:
                                                                    "col-sm-9"
                                                                },
                                                                [_vm._v("Ja")]
                                                              )
                                                            : _c(
                                                                "dd",
                                                                {
                                                                  staticClass:
                                                                    "col-sm-9"
                                                                },
                                                                [_vm._v("Nee")]
                                                              ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "dt",
                                                            {
                                                              staticClass:
                                                                "col-sm-3"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.labels
                                                                    .gezin
                                                                    .gezinsleden
                                                                    .tenLaste
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          gezinslid.tenLaste
                                                            ? _c(
                                                                "dd",
                                                                {
                                                                  staticClass:
                                                                    "col-sm-9"
                                                                },
                                                                [_vm._v("Ja")]
                                                              )
                                                            : _c(
                                                                "dd",
                                                                {
                                                                  staticClass:
                                                                    "col-sm-9"
                                                                },
                                                                [_vm._v("Nee")]
                                                              ),
                                                          _vm._v(" "),
                                                          !gezinslid.tenLaste
                                                            ? [
                                                                _c(
                                                                  "dt",
                                                                  {
                                                                    staticClass:
                                                                      "col-sm-3"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .labels
                                                                          .gezin
                                                                          .gezinsleden
                                                                          .nietMeerTenLaste
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "dd",
                                                                  {
                                                                    staticClass:
                                                                      "col-sm-9"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        gezinslid.nietMeerTenLaste
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "dt",
                                                            {
                                                              staticClass:
                                                                "col-sm-3"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.labels
                                                                    .gezin
                                                                    .gezinsleden
                                                                    .verwantschap
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "dd",
                                                            {
                                                              staticClass:
                                                                "col-sm-9"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  gezinslid.verwantschap
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        2
                                                      )
                                                    : _vm._e()
                                                }
                                              )
                                            ]
                                          : _vm._e()
                                      ]
                                    : _vm._e()
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            step.remarks
                              ? _c("dl", { staticClass: "row" }, [
                                  _c("dt", { staticClass: "col-sm-3" }, [
                                    _vm._v("Opmerking")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "dd",
                                    { staticClass: "col-sm-9 text-left" },
                                    [_vm._v(_vm._s(step.remarks))]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            step.files
                              ? _c(
                                  "dl",
                                  { staticClass: "row" },
                                  [
                                    _c("dt", { staticClass: "col-sm-3" }, [
                                      _vm._v("Bijlage(n)")
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(step.files, function(file, index) {
                                      return [
                                        _c(
                                          "dd",
                                          {
                                            key:
                                              "dd-step-files-gezin" +
                                              parseInt(index),
                                            staticClass:
                                              "col-sm-9 text-left text-primary"
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    return _vm.downloadDossierFile(
                                                      file
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: ["fad", "download"]
                                                  }
                                                }),
                                                _vm._v(
                                                  "\n                - " +
                                                    _vm._s(file.bestandsnaam) +
                                                    "\n              "
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("dt", {
                                          key:
                                            "dt-step-files-gezin" +
                                            parseInt(index),
                                          staticClass: "col-sm-3"
                                        })
                                      ]
                                    })
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-left" }, [
                              _c(
                                "span",
                                { staticClass: "text-muted font-italic" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: ["fad", "calendar"] }
                                  }),
                                  _vm._v(
                                    "\n                          " +
                                      _vm._s(step.created) +
                                      "\n                      "
                                  )
                                ],
                                1
                              )
                            ])
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.cardName == "overige"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "w-75 border-left border-primary pl-3 col-sm-11"
                          },
                          [
                            step.changes
                              ? _c(
                                  "dl",
                                  { staticClass: "row text-left" },
                                  [
                                    step.changes.rekening
                                      ? [
                                          _vm._l(
                                            step.changes.rekening.added,
                                            function(rekening, index) {
                                              return step.changes.rekening.added
                                                ? [
                                                    _c(
                                                      "dt",
                                                      {
                                                        key:
                                                          "dt-rekening-iban-added-" +
                                                          index,
                                                        staticClass: "col-sm-3"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                " +
                                                            _vm._s(
                                                              _vm.labels.overige
                                                                .rekening
                                                                .objectName
                                                                .singular
                                                            ) +
                                                            " " +
                                                            _vm._s(index + 1) +
                                                            "\n              "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "dd",
                                                      {
                                                        key:
                                                          "dd-rekening-iban-added-" +
                                                          index,
                                                        staticClass:
                                                          "col-sm-9 text-left text-success"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                (+) " +
                                                            _vm._s(
                                                              _vm.labels.overige
                                                                .rekening.iban
                                                            ) +
                                                            ": " +
                                                            _vm._s(
                                                              rekening.iban
                                                            ) +
                                                            "\n                "
                                                        ),
                                                        rekening.bic
                                                          ? _c("span", [
                                                              _vm._v(
                                                                " (" +
                                                                  _vm._s(
                                                                    _vm.labels
                                                                      .overige
                                                                      .rekening
                                                                      .bic
                                                                  ) +
                                                                  ": " +
                                                                  _vm._s(
                                                                    rekening.bic
                                                                  ) +
                                                                  ")"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  ]
                                                : _vm._e()
                                            }
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            step.changes.rekening.removed,
                                            function(rekening, index) {
                                              return step.changes.rekening
                                                .removed
                                                ? [
                                                    _c(
                                                      "dt",
                                                      {
                                                        key:
                                                          "dt-rekening-iban-removed-" +
                                                          index,
                                                        staticClass: "col-sm-3"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                " +
                                                            _vm._s(
                                                              _vm.labels.overige
                                                                .rekening
                                                                .objectName
                                                                .singular
                                                            ) +
                                                            " " +
                                                            _vm._s(index + 1) +
                                                            "\n              "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "dd",
                                                      {
                                                        key:
                                                          "dd-rekening-iban-removed-" +
                                                          index,
                                                        staticClass:
                                                          "col-sm-9 text-left text-danger"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                (-) " +
                                                            _vm._s(
                                                              _vm.labels.overige
                                                                .rekening.iban
                                                            ) +
                                                            ": " +
                                                            _vm._s(
                                                              rekening.iban
                                                            ) +
                                                            "\n                "
                                                        ),
                                                        rekening.bic
                                                          ? _c("span", [
                                                              _vm._v(
                                                                " (" +
                                                                  _vm._s(
                                                                    _vm.labels
                                                                      .overige
                                                                      .rekening
                                                                      .bic
                                                                  ) +
                                                                  ": " +
                                                                  _vm._s(
                                                                    rekening.bic
                                                                  ) +
                                                                  ")"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  ]
                                                : _vm._e()
                                            }
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    step.changes.mobiliteit
                                      ? [
                                          step.changes.mobiliteit.hasOwnProperty(
                                            "rijbewijs"
                                          )
                                            ? [
                                                _c(
                                                  "dt",
                                                  { staticClass: "col-sm-3" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.labels.overige
                                                          .rijbewijs
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                step.changes.mobiliteit
                                                  .rijbewijs
                                                  ? _c(
                                                      "dd",
                                                      {
                                                        staticClass: "col-sm-9"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                Ja\n              "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                !step.changes.mobiliteit
                                                  .rijbewijs
                                                  ? _c(
                                                      "dd",
                                                      {
                                                        staticClass: "col-sm-9"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                Nee\n              "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          step.changes.mobiliteit.nummerplaat
                                            ? [
                                                _c(
                                                  "dt",
                                                  { staticClass: "col-sm-3" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.labels.overige
                                                          .nummerplaat
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "dd",
                                                  { staticClass: "col-sm-9" },
                                                  [
                                                    _vm._v(
                                                      "\n                " +
                                                        _vm._s(
                                                          step.changes
                                                            .mobiliteit
                                                            .nummerplaat
                                                        ) +
                                                        "\n              "
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          step.changes.mobiliteit.nummerplaten
                                            ? [
                                                _vm._l(
                                                  step.changes.mobiliteit
                                                    .nummerplaten.added,
                                                  function(nummerplaat, index) {
                                                    return step.changes
                                                      .mobiliteit.nummerplaten
                                                      .added
                                                      ? [
                                                          _c(
                                                            "dt",
                                                            {
                                                              key:
                                                                "dt-nummerplaat-added-" +
                                                                index,
                                                              staticClass:
                                                                "col-sm-3"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.labels
                                                                    .overige
                                                                    .nummerplaat
                                                                ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    index + 1
                                                                  )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "dd",
                                                            {
                                                              key:
                                                                "dd-nummerplaat-added-" +
                                                                index,
                                                              staticClass:
                                                                "col-sm-9 text-left text-success"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "(+) " +
                                                                  _vm._s(
                                                                    nummerplaat.nummerplaat
                                                                  )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      : _vm._e()
                                                  }
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  step.changes.mobiliteit
                                                    .nummerplaten.removed,
                                                  function(nummerplaat, index) {
                                                    return step.changes
                                                      .mobiliteit.nummerplaten
                                                      .removed
                                                      ? [
                                                          _c(
                                                            "dt",
                                                            {
                                                              key:
                                                                "dt-nummerplaat-removed-" +
                                                                index,
                                                              staticClass:
                                                                "col-sm-3"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.labels
                                                                    .overige
                                                                    .nummerplaat
                                                                ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    index + 1
                                                                  )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "dd",
                                                            {
                                                              key:
                                                                "dd-nummerplaat-removed-" +
                                                                index,
                                                              staticClass:
                                                                "col-sm-9 text-left text-danger"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "(-) " +
                                                                  _vm._s(
                                                                    nummerplaat.nummerplaat
                                                                  )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      : _vm._e()
                                                  }
                                                )
                                              ]
                                            : _vm._e()
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    step.changes.orcid
                                      ? [
                                          _c(
                                            "dt",
                                            { staticClass: "col-sm-3" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.labels.overige.orcid)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "dd",
                                            { staticClass: "col-sm-9" },
                                            [_vm._v(_vm._s(step.changes.orcid))]
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            step.remarks
                              ? _c("dl", { staticClass: "row" }, [
                                  _c("dt", { staticClass: "col-sm-3" }, [
                                    _vm._v("Opmerking")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "dd",
                                    { staticClass: "col-sm-9 text-left" },
                                    [_vm._v(_vm._s(step.remarks))]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            step.files
                              ? _c(
                                  "dl",
                                  { staticClass: "row" },
                                  [
                                    _c("dt", { staticClass: "col-sm-3" }, [
                                      _vm._v("Bijlage(n)")
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(step.files, function(file, index) {
                                      return [
                                        _c(
                                          "dd",
                                          {
                                            key:
                                              "dd-step-files-overige" +
                                              parseInt(index),
                                            staticClass:
                                              "col-sm-9 text-left text-primary"
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    return _vm.downloadDossierFile(
                                                      file
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: ["fad", "download"]
                                                  }
                                                }),
                                                _vm._v(
                                                  "\n                - " +
                                                    _vm._s(file.bestandsnaam) +
                                                    "\n              "
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("dt", {
                                          key:
                                            "dt-step-files-overige" +
                                            parseInt(index),
                                          staticClass: "col-sm-3"
                                        })
                                      ]
                                    })
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-left" }, [
                              _c(
                                "span",
                                { staticClass: "text-muted font-italic" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: ["fad", "calendar"] }
                                  }),
                                  _vm._v(
                                    "\n                          " +
                                      _vm._s(step.created) +
                                      "\n                      "
                                  )
                                ],
                                1
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              step.requestStatus == "InProgress"
                ? _c(
                    "div",
                    { class: [index == 0 ? "row mt-2" : "row mt-2 mb-4"] },
                    [
                      index != 0
                        ? [
                            _c(
                              "div",
                              { staticClass: "col-sm-1 text-secondary" },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: ["fad", "user"] }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "w-75 border-left border-secondary pl-3 col-sm-11 text-left text-secondary"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-left font-weight-bold my-2"
                                  },
                                  [
                                    _vm._v(
                                      "\n            U stuurde deze aanvulling in voor deze aanvraag:\n          "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("dl", { staticClass: "row mb-0" }, [
                                  _c("dt", { staticClass: "col-sm-3" }, [
                                    _vm._v("Opmerking")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "dd",
                                    { staticClass: "col-sm-9 text-left" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.wijziging.steps[index].remarks
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                step.files
                                  ? _c(
                                      "dl",
                                      { staticClass: "row" },
                                      [
                                        _c("dt", { staticClass: "col-sm-3" }, [
                                          _vm._v("Bijlage(n)")
                                        ]),
                                        _vm._v(" "),
                                        _vm._l(step.files, function(
                                          file,
                                          index
                                        ) {
                                          return [
                                            _c(
                                              "dd",
                                              {
                                                staticClass:
                                                  "col-sm-9 text-left text-primary"
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.downloadDossierFile(
                                                          file
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: [
                                                          "fad",
                                                          "download"
                                                        ]
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                  - " +
                                                        _vm._s(
                                                          file.bestandsnaam
                                                        ) +
                                                        "\n                "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("dt", {
                                              staticClass: "col-sm-3"
                                            })
                                          ]
                                        })
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "text-left" }, [
                                  _c(
                                    "span",
                                    { staticClass: "text-muted font-italic" },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: ["fad", "calendar"] }
                                      }),
                                      _vm._v(
                                        "\n                              " +
                                          _vm._s(step.created) +
                                          "\n                          "
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              step.requestStatus == "InProgress"
                ? _c(
                    "div",
                    { class: [index == 0 ? "row mt-2" : "row mt-2 mb-4"] },
                    [
                      index == _vm.wijziging.steps.length - 1
                        ? [
                            _c(
                              "div",
                              { staticClass: "col-sm-1 text-secondary" },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: ["fad", "user-cog"] }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "w-75 border-left border-secondary pl-3 col-sm-11 text-left text-secondary"
                              },
                              [
                                _vm._v(
                                  "\n          ... wachten op verwerking door HR.\n        "
                                )
                              ]
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              step.requestStatus == "NeedsInfo"
                ? [
                    _c("div", { staticClass: "row mb-4" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-1 text-primary" },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: ["fad", "exclamation"] }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "w-75 border-left border-primary pl-3 col-sm-11 text-left text-secondary"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "alert alert-primary step-remarks",
                              attrs: { role: "alert" }
                            },
                            [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v("Melding HR: ")
                              ]),
                              _vm._v(_vm._s(step.remarks) + "\n          ")
                            ]
                          ),
                          _vm._v(" "),
                          [
                            _c("div", { staticClass: "text-left" }, [
                              _c(
                                "span",
                                { staticClass: "text-muted font-italic" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: ["fad", "calendar"] }
                                  }),
                                  _vm._v(
                                    "\n                                  " +
                                      _vm._s(step.created) +
                                      "\n                              "
                                  )
                                ],
                                1
                              )
                            ])
                          ]
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    index == _vm.wijziging.steps.length - 1
                      ? _c("div", { staticClass: "row mb-4" }, [
                          _c(
                            "div",
                            { staticClass: "col-sm-1 text-secondary" },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["fad", "user"] }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "w-75 border-left border-secondary pl-3 col-sm-11 text-left"
                            },
                            [_vm._t("default")],
                            2
                          )
                        ])
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              step.requestStatus == "Accepted"
                ? _c("div", { staticClass: "row mt-2" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-1 text-success" },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: ["far", "check"] }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "w-75 border-left border-success pl-3 col-sm-11 text-left text-success"
                      },
                      [
                        _c("span", [_vm._v("Uw aanvraag werd goedgekeurd.")]),
                        _vm._v(" "),
                        _vm.wijziging.steps[_vm.wijziging.steps.length - 1]
                          .remarks
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "alert alert-success step-remarks mt-2",
                                  attrs: { role: "alert" }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Melding HR: ")]
                                  ),
                                  _vm._v(
                                    _vm._s(
                                      _vm.wijziging.steps[
                                        _vm.wijziging.steps.length - 1
                                      ].remarks
                                    ) + "\n          "
                                  )
                                ]
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              step.requestStatus == "Rejected"
                ? _c("div", { staticClass: "row mt-2" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-1 text-danger" },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: ["far", "times"] }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "w-75 border-left border-danger pl-3 col-sm-11 text-left text-danger"
                      },
                      [
                        _c("span", [_vm._v("Uw aanvraag werd geweigerd.")]),
                        _vm._v(" "),
                        _vm.wijziging.steps[_vm.wijziging.steps.length - 1]
                          .remarks
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "alert alert-danger step-remarks mt-2",
                                  attrs: { role: "alert" }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Melding HR: ")]
                                  ),
                                  _vm._v(
                                    _vm._s(
                                      _vm.wijziging.steps[
                                        _vm.wijziging.steps.length - 1
                                      ].remarks
                                    ) + "\n          "
                                  )
                                ]
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                : _vm._e()
            ],
            2
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }